/* tslint:disable */
import {
  StockWarehouseLocation,
  PartnerAddress,
  Product,
  ProductUom,
  Company,
  StockLocation,
  ManufacturingProductionOrderLine,
  ManufacturingWorkLine,
  ProductionOrder
} from '../index';

declare var Object: any;
export interface ManufacturingProductionOrderInterface {
  "id"?: number;
  "name"?: string;
  "warehouse_location_id"?: number;
  "date"?: Date;
  "partner_id"?: number;
  "default_product_id"?: number;
  "production_hour_uom_qty"?: number;
  "production_hour_uom"?: number;
  "mixture"?: string;
  "packages"?: number;
  "production_filter"?: number;
  "observations"?: string;
  "state"?: string;
  "company_id"?: number;
  "manufacturing_lines_ids"?: Array<any>;
  "production_order_ids"?: Array<any>;
  "production_order_count"?: number;
  "next_package_seq"?: number;
  "next_lot_seq"?: number;
  "in_location_id"?: number;
  "production_location_id"?: number;
  "out_location_id"?: number;
  "no_quality_location_id"?: number;
  "default_production_uom_qty"?: number;
  "default_production_uom"?: number;
  "default_packages"?: number;
  "line_id"?: number;
  warehouseLocation?: StockWarehouseLocation;
  partner?: PartnerAddress;
  defaultProduct?: Product;
  productionHourUom?: ProductUom;
  company?: Company;
  inLocation?: StockLocation;
  productionLocation?: StockLocation;
  outLocation?: StockLocation;
  noQualityLocation?: StockLocation;
  defaultProductionUom?: ProductUom;
  manufacturingLines?: ManufacturingProductionOrderLine[];
  line?: ManufacturingWorkLine;
  productionOrders?: ProductionOrder[];
}

export class ManufacturingProductionOrder implements ManufacturingProductionOrderInterface {
  "id": number;
  "name": string;
  "warehouse_location_id": number;
  "date": Date;
  "partner_id": number;
  "default_product_id": number;
  "production_hour_uom_qty": number;
  "production_hour_uom": number;
  "mixture": string;
  "packages": number;
  "production_filter": number;
  "observations": string;
  "state": string;
  "company_id": number;
  "manufacturing_lines_ids": Array<any>;
  "production_order_ids": Array<any>;
  "production_order_count": number;
  "next_package_seq": number;
  "next_lot_seq": number;
  "in_location_id": number;
  "production_location_id": number;
  "out_location_id": number;
  "no_quality_location_id": number;
  "default_production_uom_qty": number;
  "default_production_uom": number;
  "default_packages": number;
  "line_id": number;
  warehouseLocation: StockWarehouseLocation;
  partner: PartnerAddress;
  defaultProduct: Product;
  productionHourUom: ProductUom;
  company: Company;
  inLocation: StockLocation;
  productionLocation: StockLocation;
  outLocation: StockLocation;
  noQualityLocation: StockLocation;
  defaultProductionUom: ProductUom;
  manufacturingLines: ManufacturingProductionOrderLine[];
  line: ManufacturingWorkLine;
  productionOrders: ProductionOrder[];
  constructor(data?: ManufacturingProductionOrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ManufacturingProductionOrder`.
   */
  public static getModelName() {
    return "ManufacturingProductionOrder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ManufacturingProductionOrder for dynamic purposes.
  **/
  public static factory(data: ManufacturingProductionOrderInterface): ManufacturingProductionOrder{
    return new ManufacturingProductionOrder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ManufacturingProductionOrder',
      plural: 'ManufacturingProductionOrders',
      path: 'ManufacturingProductionOrders',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "warehouse_location_id": {
          name: 'warehouse_location_id',
          type: 'number'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "default_product_id": {
          name: 'default_product_id',
          type: 'number'
        },
        "production_hour_uom_qty": {
          name: 'production_hour_uom_qty',
          type: 'number'
        },
        "production_hour_uom": {
          name: 'production_hour_uom',
          type: 'number'
        },
        "mixture": {
          name: 'mixture',
          type: 'string'
        },
        "packages": {
          name: 'packages',
          type: 'number'
        },
        "production_filter": {
          name: 'production_filter',
          type: 'number'
        },
        "observations": {
          name: 'observations',
          type: 'string'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "manufacturing_lines_ids": {
          name: 'manufacturing_lines_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "production_order_ids": {
          name: 'production_order_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "production_order_count": {
          name: 'production_order_count',
          type: 'number'
        },
        "next_package_seq": {
          name: 'next_package_seq',
          type: 'number'
        },
        "next_lot_seq": {
          name: 'next_lot_seq',
          type: 'number'
        },
        "in_location_id": {
          name: 'in_location_id',
          type: 'number'
        },
        "production_location_id": {
          name: 'production_location_id',
          type: 'number'
        },
        "out_location_id": {
          name: 'out_location_id',
          type: 'number'
        },
        "no_quality_location_id": {
          name: 'no_quality_location_id',
          type: 'number'
        },
        "default_production_uom_qty": {
          name: 'default_production_uom_qty',
          type: 'number'
        },
        "default_production_uom": {
          name: 'default_production_uom',
          type: 'number'
        },
        "default_packages": {
          name: 'default_packages',
          type: 'number'
        },
        "line_id": {
          name: 'line_id',
          type: 'number'
        },
      },
      relations: {
        warehouseLocation: {
          name: 'warehouseLocation',
          type: 'StockWarehouseLocation',
          model: 'StockWarehouseLocation',
          relationType: 'belongsTo',
                  keyFrom: 'warehouse_location_id',
          keyTo: 'id'
        },
        partner: {
          name: 'partner',
          type: 'PartnerAddress',
          model: 'PartnerAddress',
          relationType: 'belongsTo',
                  keyFrom: 'partner_id',
          keyTo: 'id'
        },
        defaultProduct: {
          name: 'defaultProduct',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'default_product_id',
          keyTo: 'id'
        },
        productionHourUom: {
          name: 'productionHourUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'production_hour_uom',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        inLocation: {
          name: 'inLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'in_location_id',
          keyTo: 'id'
        },
        productionLocation: {
          name: 'productionLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'production_location_id',
          keyTo: 'id'
        },
        outLocation: {
          name: 'outLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'out_location_id',
          keyTo: 'id'
        },
        noQualityLocation: {
          name: 'noQualityLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'no_quality_location_id',
          keyTo: 'id'
        },
        defaultProductionUom: {
          name: 'defaultProductionUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'default_production_uom',
          keyTo: 'id'
        },
        manufacturingLines: {
          name: 'manufacturingLines',
          type: 'ManufacturingProductionOrderLine[]',
          model: 'ManufacturingProductionOrderLine',
          relationType: 'referencesMany',
                  keyFrom: 'manufacturing_lines_ids',
          keyTo: 'id'
        },
        line: {
          name: 'line',
          type: 'ManufacturingWorkLine',
          model: 'ManufacturingWorkLine',
          relationType: 'belongsTo',
                  keyFrom: 'line_id',
          keyTo: 'id'
        },
        productionOrders: {
          name: 'productionOrders',
          type: 'ProductionOrder[]',
          model: 'ProductionOrder',
          relationType: 'referencesMany',
                  keyFrom: 'production_order_ids',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ManufacturingProductionOrder.ts